import typography from "./typography";

const sizeOverrides = {
  sm: {
    padding: "8px 14px",
    ...typography.body14SemiBold,
    lineHeight: "normal",
  },
  md: {
    padding: "10px 16px",
    ...typography.body14SemiBold,
    lineHeight: "normal",
  },
  lg: {
    padding: "10px 18px",
    ...typography.body16SemiBold,
    lineHeight: "normal",
  },
  xl: {
    padding: "12px 20px",
    ...typography.body16SemiBold,
    lineHeight: "normal",
  },
};

export default sizeOverrides;
